import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { authenticationSeletor } from "../store/slices/authenticationSlice";

const ProtectedRoute = ({ children, allowedFor = [] }) => {
  const [searchParams] = useSearchParams();
  const user_id = !!searchParams.get("user_id");
  const fromMobile = searchParams.get("platform") == "mobile_app";
  const navigate = useNavigate();
  const location = useLocation()
  const { userDetail } = useSelector(authenticationSeletor);

  const fromMobileAuth = () => {
    if (userDetail?.id && userDetail?.logintype !== "normalUser") {
      return;
    }
    if (!fromMobile || !user_id || userDetail?.logintype === "normalUser") {
      navigate("/");
      return;
    }
  };

  useEffect(() => {
    fromMobileAuth();
  }, [userDetail, fromMobile, user_id]);

  useEffect(() => {
    if (!userDetail?.logintype) return;
    if (allowedFor.length > 0 && !allowedFor.includes(userDetail.logintype)) {
      navigate("/unauthorized");
    }
  }, [userDetail, allowedFor]);

  return <>{children}</>;
};

export default ProtectedRoute;
